export default __webpack_public_path__ + "static/SRF 2100 - Fiche de spécifications et données techniques-b9a1095150b8d1e0724e06af8b091c17.pdf";